import React from 'react';
import IndustryMaster from '../components/masters/IndustryMaster';

const Industries = () => {
  return <IndustryMaster />;
};

export default Industries;